const recibosModule = {
  namespaced: true,
  state: {
    selected: [],
    firmadorSelected: null
  },
  mutations: {
    setSelected (state, recibos) {
      state.selected = recibos
    },
    setFirmadorSelected (state, firmadorSelected) {
      state.firmadorSelected = firmadorSelected
    },
    unload (state) {
      state.selected = []
      state.firmadorSelected = null
    }
  },
  getters: {},
  actions: {
    unload (context) {
      context.commit('unload')
    }
  }
}

export default recibosModule
